var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetSuccessSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "welcome 1",
    clipPath: "url(#clip0_5109_56460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.41187 5.13165C6.3406 7.8106 4.38574 11.8463 4.38574 16.3603C4.38574 23.2726 8.96956 29.0632 15.1264 30.5781",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25208 6.25967L7.94451 5.57748C7.54752 4.69691 7.62916 3.66137 8.15865 2.86101L9.0069 1.57881C9.12893 1.39431 9.39986 1.4362 9.46581 1.64978L9.77727 2.65834C10.0015 3.38438 9.92492 4.17558 9.56611 4.83966L9.41201 5.12494",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.66337 10.2173L5.16942 9.66823C4.53184 8.95957 4.3036 7.9484 4.57071 7.01568L4.99865 5.52143C5.06023 5.30646 5.33025 5.25847 5.45603 5.44012L6.05015 6.29822C6.47782 6.91591 6.63865 7.69315 6.49371 8.44093L6.43145 8.76221",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.13658 15.3882L3.54336 14.9604C2.77771 14.4082 2.35144 13.47 2.42522 12.4993L2.54337 10.9441C2.56038 10.7204 2.81471 10.614 2.97416 10.7639L3.72731 11.4718C4.26944 11.9814 4.58285 12.7057 4.59132 13.4688L4.59493 13.7966",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.96927 20.5344L4.25147 20.4762C3.32501 20.4011 2.50714 19.814 2.10598 18.9358L1.4634 17.5289C1.37097 17.3265 1.53987 17.1008 1.74958 17.1466L2.73982 17.3629C3.45262 17.5186 4.0705 17.9802 4.44327 18.6355L4.60336 18.9171",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.22687 25.1947L6.54688 25.4431C5.6692 25.7637 4.69482 25.5694 3.99095 24.9334L2.86338 23.9145C2.70116 23.7679 2.76953 23.49 2.97916 23.4438L3.96937 23.2257C4.68219 23.0687 5.42514 23.2321 6.01766 23.6759L6.27221 23.8665",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.6979 28.5724L10.1354 29.0434C9.40922 29.6514 8.42866 29.8073 7.56299 29.4524L6.17622 28.8839C5.97672 28.802 5.95305 28.5162 6.13617 28.3997L7.00094 27.8493C7.62345 27.4531 8.37598 27.3484 9.07561 27.5608L9.37618 27.652",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.2331 5.13165C30.3043 7.8106 32.2592 11.8463 32.2592 16.3603C32.2592 23.2726 27.6754 29.0632 21.5186 30.5781",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M28.3859 6.25967L28.6935 5.57748C29.0904 4.69691 29.0088 3.66137 28.4793 2.86101L27.6311 1.57881C27.509 1.39431 27.2381 1.4362 27.1722 1.64978L26.8607 2.65834C26.6365 3.38438 26.7131 4.17558 27.0719 4.83966L27.226 5.12494",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M30.983 10.2173L31.4769 9.66823C32.1145 8.95957 32.3428 7.9484 32.0756 7.01568L31.6477 5.52143C31.5861 5.30646 31.3161 5.25847 31.1903 5.44012L30.5962 6.29822C30.1685 6.91591 30.0077 7.69315 30.1526 8.44093L30.2149 8.76221",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.5111 15.3882L33.1043 14.9604C33.8699 14.4082 34.2962 13.47 34.2224 12.4993L34.1043 10.9441C34.0873 10.7204 33.8329 10.614 33.6735 10.7639L32.9203 11.4718C32.3782 11.9814 32.0648 12.7057 32.0563 13.4688L32.0527 13.7966",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.6787 20.5344L32.3965 20.4762C33.323 20.4011 34.1408 19.814 34.542 18.9358L35.1846 17.5289C35.277 17.3265 35.1081 17.1008 34.8984 17.1466L33.9082 17.3629C33.1954 17.5186 32.5775 17.9802 32.2047 18.6355L32.0446 18.9171",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M29.4199 25.1947L30.0999 25.4431C30.9776 25.7637 31.952 25.5694 32.6558 24.9334L33.7834 23.9145C33.9456 23.7679 33.8773 23.49 33.6676 23.4438L32.6774 23.2257C31.9645 23.0687 31.2216 23.2321 30.6291 23.6759L30.3745 23.8665",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M25.9521 28.5724L26.5147 29.0434C27.2408 29.6514 28.2214 29.8073 29.0871 29.4524L30.4738 28.8839C30.6733 28.802 30.697 28.5162 30.5139 28.3997L29.6491 27.8493C29.0266 27.4531 28.2741 27.3484 27.5744 27.5608L27.2739 27.652",
    stroke: "#BB3240",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.324 8.86719L20.5396 13.5702L25.4937 14.3243L21.9088 17.9851L22.7551 23.1542L18.324 20.7137L13.8929 23.1542L14.7391 17.9851L11.1543 14.3243L16.1084 13.5702L18.324 8.86719Z",
    fill: "#FDB022",
    stroke: "#F79009",
    strokeWidth: 1.33305,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5109_56460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSuccessSvg);
export default __webpack_public_path__ + "static/media/resetSuccessSvg.4b2fb2dc41e94237caeb3fd7a6d86f18.svg";
export { ForwardRef as ReactComponent };